import Cookies from 'js-cookie';

import { Experiments, getVisitorId } from '@ratehub/base-ui';


const MTG_AFFILIATE_COOKIE = 'rh-aff-offer-2';

/**
 * Constructs the base payload to send to the conversion service
 * @param {object} obj
 * @param {object} obj.rate
 * @param {string} obj.cityName
 * @param {string} obj.provinceCode
 * @param {string} obj.locale
 * @param {object} obj.experiments
 * @returns {object}
 */
export default function createBaseConversionPayload({ rate, cityName, provinceCode, locale, experiments }) {
    let affiliateCookie;

    try {
        affiliateCookie = JSON.parse(Cookies.get(MTG_AFFILIATE_COOKIE));
    } catch {
        // intentionally empty
    }

    return {
        'productType': 'MORTGAGE',
        'city': cityName,
        'province': provinceCode,
        'language': locale,
        'conversionSourceType': 'MORTGAGE_RATE',
        'conversionSourceId': rate.id,
        'conversionSourceDetails': {
            interestRate: rate.value,
        },
        'provider': {
            slug: rate.provider.slug,
        },
        'experiments': {
            'mortgages': {
                ...Experiments.toJSON(),
                ...experiments,
                'lipstickOnAPig': 1,
            },
        },
        visitor: getVisitorId() ?? '0',
        ...(affiliateCookie?.aff_id && {
            affiliate: affiliateCookie,
        }),
    };
}
